import moment from "moment";
import endpoints from "@/endpoints";
import axiosApi from "@/axios";

export const formatDate = (date) => moment(date).format("DD/MM/YYYY");

// Age in whole years from a date of birth such as "1980-05-13". The date is read as written:
// new Date() would take it as UTC midnight, the day before west of London, and turn a
// birthday into the day after it there.
export const ageFrom = (dateOfBirth, today = new Date()) => {
    const parts = String(dateOfBirth ?? "").match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (!parts) return null;
    const [year, month, day] = parts.slice(1).map(Number);
    let age = today.getFullYear() - year;
    const beforeBirthday = today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day);
    if (beforeBirthday) age--;
    return age >= 0 ? age : null;
};

async function saveField(profile, field) {
    try {
        const { data } = await axiosApi.put(`${endpoints.profile}/${profile.barcode}`, {
            profile: {
                ...profile,
                ...field,
            },
        });
        return data;
    } catch (e) {
        console.log("Profile save error", e);
        throw e;
    }
}

class ProfileService {
    static async getDefaultProfile() {
        const {
            data: { profile },
        } = await axiosApi.get(`${endpoints.profile}`);
        return profile;
    }

    static async getProfiles() {
        const { data } = await axiosApi.get(endpoints.profiles);
        return data;
    }

    static async setDefaultProfile(id) {
        const { data } = await axiosApi.put(`${endpoints.profile}/default/${id}`);
        return data;
    }

    static async getFullProfile(barcode) {
        const { data } = await axiosApi.get(`${endpoints.profile}/${barcode}`);
        return data;
    }

    static async editProfile(barcode, payload) {
        const { data } = await axiosApi.put(`${endpoints.profile}/${barcode}`, payload);
        return data;
    }

    static async editFamilyMatchingConsent(barcode, payload) {
        const { data } = await axiosApi.put(endpoints.allConsents(barcode), payload);
        return data;
    }

    static async reuploadDnaFile(barcode, file) {
        const { data } = await axiosApi.put(endpoints.reuploadDnaFile, {
            barcode,
            file,
        });
        return data;
    }

    static async saveName(barcode, name, profile) {
        return saveField(profile, { name });
    }

    static async saveAvatar(profile, photo) {
        try {
            console.log({profile: {
                ...profile,
                photo,
            }});
            const { data } = await axiosApi.put(`${endpoints.profile}/${profile.barcode}`, {
                profile: {
                    ...profile,
                    photo,
                },
            });
            return data;
        } catch (e) {
            console.log("Profile save error", e);
            throw e;
        }
    }

    static async saveBio(profile, bio) {
        return saveField(profile, bio);
    }

    static async checkPassword(username, password) {
        try {
            const response = await fetch(endpoints.checkPassword, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ _username: username, _password: password }),
            });
            if (!response.ok) {
                throw new Error();
            }
        } catch (e) {
            console.error(e)
            throw e;
        }
    }

    static async deleteAvatar(barcode) {
        try {
            await axiosApi.delete(endpoints.avatar(barcode));
        } catch (e) {
            console.log("there was an error", e);
        }
    }

    static async getFamilyNetworkSharingPermissions(barcode) {
        try {
            const { data } = await axiosApi.get(endpoints.familyNetworkSharingPermissions(barcode));
            return data;
        } catch (e) {
            console.error(`Error fetching fn sharing permissions for ${barcode}`);
            throw new Error(e);
        }
    }

    static async setFamilyNetworkSharingPermissions(barcode, payload) {
        try {
            const { data } = await axiosApi.post(endpoints.familyNetworkSharingPermissions(barcode), payload);
            return data;
        } catch (e) {
            console.error(`Error fetching fn sharing permissions for ${barcode}`, e);
            throw new Error(e);
        }
    }
    static async getShareProfileStatus(barcode) {
        try {
           
            const {data} = await axiosApi.get(endpoints.publicProfileAdmin(barcode));
            return data;
        } catch (e) {
            console.error(e);
        }
    }
    static async shareProfile(barcode, value) {
        try {
            const {data} = await axiosApi.post(endpoints.publicProfileAdmin(barcode), {active: value});
            return data;
        } catch (e) {
            console.error(e);
            throw e;
        }
    }
    static async deleteProfile(barcode) {
        try {
            const {data} = await axiosApi.delete(endpoints.getProfile(barcode))
            return data;
        } catch (e) {
            console.error(e);
        }
    }

    static async getResearchData(barcode) {
        try {
            const {data} = await axiosApi.get(endpoints.research(barcode))
            return data;
        } catch (e) {
            console.error(e);
        }
    }
    static async setResearchData(barcode, payload) {
        try {
            const {data} = await axiosApi.post(endpoints.research(barcode), payload)
            return data;
        } catch (e) {
            console.error(e);
        }
    }
}

export default ProfileService;

export const isUnder18 = (profile) =>
    moment().diff(moment(profile.dateOfBirth), "years", false) >= 18;
